// extracted by mini-css-extract-plugin
export var dividerNavbar = "gT_ps";
export var loginSignupLink = "gT_pr";
export var navMenuSecondary = "gT_pq";